import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import './app.css'
import Navbar from './components/navbar'
import Verify from './components/verify'

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Navbar />
        <Switch>
          <Route path="/verify/:graduateId" component={Verify} />
          <Route exact path="/" component={Home} />
        </Switch>
      </div>
    </BrowserRouter>
  );

}

function Home() {
  return <p className="padding20 centered-row container">Welcome to SuaCode.ai home</p>
}

export default App;
